// import { carouselSettings } from "../utils/Carrousel.config";
// import Slider from "react-slick";
import iiifiumsabo from "../assets/inicio/iii3.mp4";
import iiifi from "../images/resources/iiifi.png"
import posgrado from "../images/resources/posgrado.png"
import iiifi0 from "../images/resources/iiifi0.png"

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Divider, Grid, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";

import PlaceIcon from '@mui/icons-material/Place';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';


import AnimatedSection from "../components/AnimatedSection";
function Inicio() {
  return (
    <>
      <Stack spacing={4}>
        <Typography color="success" variant="h2" align="center" sx={{ my: 2 }}>
          <strong>BIENVENIDO AL IIIFI</strong>
        </Typography>
        <AnimatedSection>
          <Typography
            variant="h6"
            align="center"
            sx={{
              px: 6,
              backgroundImage: `url(${iiifi0})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              px: 2,
              py: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 2,
              color: "white",
              textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          >
            <strong>
              El pleno del Honorable Consejo Universitario aprobó la creación
              del Instituto de Investigaciones Industriales (IIIFI) mediante
              Resolución 85-91 del 18 de junio de 1991.
              <br /> El IIIFI desarrolla actividades en cuatro áreas:
              Investigación Aplicada, Desarrollo Industrial, Capacitación de
              Recursos Humanos y Servicios Industriales.
            </strong>
          </Typography>
        </AnimatedSection>
        <Divider />
        {/* <Slider {...carouselSettings}>
        <div>Hola</div>
      </Slider> */}
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          style={{
            // position: "absolute",
            // top: 0,
            // left: 0,
            alignSelf: "center",
            width: "80%",
            height: "80%",
            pointerEvents: "none", // 👈 Bloquea toda interacción
            userSelect: "none", // 👈 Evita selección
            appearance: "none",
            // objectFit: "cover",
            // zIndex: -1,
          }}
        >
          <source src={iiifiumsabo} type="video/mp4" />
          Tu navegador no soporta video HTML5.
        </video>
        <Divider />
        <AnimatedSection>
          <Typography variant="h6" align="center" sx={{ px: 6 }}>
            <strong>
              "La ciencia tecnología e innovación, evolucionan de manera
              exponencial, en un contexto en el que la problemática económica,
              política y sanitaria. se ve cada vez más afectada por la crisis
              ambiental y el cambio climático. Asi la sociendad boliviana
              demanda soluciones a diversos problemas que enfrenta a nivel
              nacional, departamental, municipal y local."
            </strong>
          </Typography>
        </AnimatedSection>
        <Divider />
        <Typography variant="h4" align="center">
          <strong>Nuestras oficinas</strong>
        </Typography>
      </Stack>
      <br />
      <AnimatedSection>
        <Grid container spacing={2} width={"100%"}>
          <Grid item size={{ xs: 12, md: 6 }}>
            <Stack
              spacing={2}
              sx={{
                width: "100%",
                backgroundImage: `url(${iiifi})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                padding: 2,
                borderRadius: 2,
                color: "white",
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              }}
            >
              <Typography
                variant="h6"
                align="center"
                sx={{ marginTop: 2, marginBottom: -1 }}
              >
                <strong>
                  Instituto de Investigaciones Industriales UMSA
                  <br />
                  Oficinas Cota Cota
                </strong>
              </Typography>
              <List>
                <ListItem
                  sx={{
                    background: "rgba(255, 255, 255, 0.3)",
                    borderRadius: 1,
                    mb: 1,
                  }}
                >
                  <ListItemIcon>
                    <PlaceIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText primary="Campus UMSA Calle 31, Cota Cota." />
                </ListItem>
                <ListItem
                  sx={{
                    background: "rgba(255, 255, 255, 0.3)",
                    borderRadius: 1,
                    mb: 1,
                  }}
                >
                  <ListItemIcon>
                    <LocalPhoneIcon color="disabled" />
                  </ListItemIcon>
                  <ListItemText primary="Teléfono: 2917439" />
                </ListItem>
              </List>
              <iframe
                title="Oficinas Cota Cota"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6814.96083856942!2d-68.06556132272202!3d-16.537803219576364!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x915f21deaa4ab80f%3A0x9e956db5ab57e640!2sIngenier%C3%ADa%20Industrial!5e0!3m2!1ses-419!2sbo!4v1759724865000!5m2!1ses-419!2sbo"
                width="100%"
                height="450"
                style={{ border: 0, padding: 4 }}
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </Stack>
          </Grid>
          <Grid item size={{ xs: 12, md: 6 }}>
            <Stack
              spacing={2}
              sx={{
                width: "100%",
                backgroundImage: `url(${posgrado})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                padding: 2,
                borderRadius: 2,
                color: "white",
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              }}
            >
              <Typography
                variant="h6"
                align="center"
                sx={{ marginTop: 2, marginBottom: -1 }}
              >
                <strong>
                  Posgrado del Instituto de Investigaciones Industriales UMSA
                  <br />
                  Oficinas Obelisco
                </strong>
              </Typography>
              <List>
                <ListItem
                  sx={{
                    background: "rgba(255, 255, 255, 0.3)",
                    borderRadius: 1,
                    mb: 1,
                  }}
                >
                  <ListItemIcon>
                    <PlaceIcon />
                  </ListItemIcon>
                  <ListItemText primary="Campus UMSA Calle 31, Cota Cota." />
                </ListItem>
                <ListItem
                  sx={{
                    background: "rgba(255, 255, 255, 0.3)",
                    borderRadius: 1,
                    mb: 1,
                  }}
                >
                  <ListItemIcon>
                    <LocalPhoneIcon />
                  </ListItemIcon>
                  <ListItemText primary="Teléfono: 2129854" />
                </ListItem>
                <ListItem
                  sx={{
                    background: "rgba(255, 255, 255, 0.3)",
                    borderRadius: 1,
                    mb: 1,
                  }}
                >
                  <ListItemIcon>
                    <LocalPhoneIcon />
                  </ListItemIcon>
                  <ListItemText primary="Teléfono: 2205000 / Int. 1410 - 1406" />
                </ListItem>
              </List>

              <iframe
                title="Oficinas Obelisco"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15302.191216156727!2d-68.14522092130154!3d-16.498419347918944!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x915f21d3e0489e2b%3A0x7f60320032678a58!2sInstituto%20de%20Investigaciones%20Industriales%20UMSA!5e0!3m2!1ses-419!2sbo!4v1759724500361!5m2!1ses-419!2sbo"
                width="100%"
                height="450"
                style={{ border: 0, padding: 4 }}
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </Stack>
          </Grid>
        </Grid>
      </AnimatedSection>
    </>
  );
}

export default Inicio;
